export const styles = {
  durationInput: {
    display: "inline-flex",
    alignItems: "center",
    height: "55px",
    padding: "0px 13px",
    borderRadius: "5px",
    background: "var(--White)",
    border: "1px solid var(--EventsGrayPrimay)",
    boxShadow: "4px 4px 4px 0px #0c38911a",
    svg: {
      marginRight: "5px",
    },
    "input::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "input::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    input: {
      MozAppearance: "textfield",
      width: "24px",
      boxSizing: "border-box",
      textAlign: "center",
      fontSize: "14px",
      position: "relative",
      top: "1px",
      "&:active, &:focus, &": {
        outline: "none",
        border: "none",
      },
    },
  },
};
